module.exports = __webpack_public_path__ + "img/barilla.svg?ff2c09c99c36ca1b1d53d4694c562b95";